<template>
  <v-app>
    <v-main>
      <Header />
      <router-view @initIcon="initIconAvailable"></router-view>
      <v-row justify="center" class="switch-icon-area" no-gutters>
        <v-col
          cols="11"
          xs="11"
          sm="10"
          md="10"
          lg="8"
          v-if="this.deviceName === 'pc'"
        >
          <v-row justify="center" no-gutters>
            <v-col cols="3" v-for="n in 4" :key="n">
              <SwitchIcon
                :icon-name="iconName(n)"
                :icon-image-url="iconImageUrl[n - 1]"
                @clickAction="switchAction(n)"
                :is-available="iconAvailables[n - 1]"
              />
            </v-col>
          </v-row>
        </v-col>
        <v-col
          cols="12"
          xs="12"
          sm="10"
          md="10"
          lg="8"
          class="sp-icon-area"
          v-else
        >
          <v-row justify="center" no-gutters>
            <v-col cols="2" v-for="n in 5" :key="n" class="narrow-padding-col">
              <SwitchIcon
                :icon-name="iconName(n)"
                :icon-image-url="iconImageUrl[n - 1]"
                @clickAction="switchAction(n)"
                :is-available="iconAvailables[n - 1]"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <Footer v-if="this.deviceName === 'pc'" />
    </v-main>
  </v-app>
</template>

<script>
import Header from "./components/Organisms/Header";
import Footer from "./components/Organisms/Footer";
import SwitchIcon from "./components/Atoms/SwitchIcon";

export default {
  data: () => ({
    pcIconNames: [
      "水槽を見る",
      "チェックする",
      "ポイントを見る",
      "他のチームを見る"
    ],
    spIconNames: ["水槽", "チェック", "ポイント", "他のチーム", "ログアウト"],
    iconImageUrl: [
      "/icon/seaweed.png",
      "/icon/check_box.png",
      "/icon/look_point.png",
      "/icon/other_teams.png",
      "/icon/right_arrow.png"
    ],
    iconAvailables: [false, false, false, false, false],
    teamId: "",
    teamIds: [],
    userAuthority: ""
  }),
  created() {
    this.initIconAvailable();
  },
  components: {
    Header,
    Footer,
    SwitchIcon
  },
  computed: {
    deviceName() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "sp";
        case "sm":
        case "md":
        case "lg":
        case "xl":
          return "pc";
        default:
          return "pc";
      }
    }
  },
  methods: {
    initIconAvailable() {
      // 各アイコンをavailableの切り替え
      for (let i = 0; i < this.iconAvailables.length; i++) {
        this.iconAvailables[i] = false;
      }
      switch (this.$route.path) {
        case "/top":
          this.$set(this.iconAvailables, 0, true);
          break;
        case "/check":
        case "/addItem":
        case "/addItemResult":
          this.$set(this.iconAvailables, 1, true);
          break;
        case "/point":
          this.$set(this.iconAvailables, 2, true);
          break;
        case "/otherTeam":
          this.$set(this.iconAvailables, 3, true);
          break;
      }
    },
    switchAction(n) {
      switch (n) {
        case 1:
          this.toTop();
          break;
        case 2:
          this.toCheck();
          break;
        case 3:
          this.toPoint();
          break;
        case 4:
          this.toOtherTeam();
          break;
        case 5:
          this.logout();
          break;
      }
      // 各アイコンをavailableの切り替え
      for (let i = 0; i < this.iconAvailables.length; i++) {
        this.iconAvailables[i] = false;
      }
      this.iconAvailables[n - 1] = true;
    },
    toTop() {
      this.$router.push("top");
    },
    toCheck() {
      this.$router.push("check");
    },
    toPoint() {
      this.$router.push("point");
    },
    toOtherTeam() {
      this.$router.push("otherTeam");
    },
    logout() {
      this.$router.push("/");
      window.localStorage.removeItem("vuex");
    },
    iconName(index) {
      if (this.deviceName === "pc") {
        return this.pcIconNames[index - 1];
      } else {
        return this.spIconNames[index - 1];
      }
    }
  }
};
</script>

<style lang="scss">
.switch-icon-area {
  padding: 0;
}
.narrow-padding-col {
  padding: 12px 0;
}
.sp-icon-area {
  background: transparent linear-gradient(180deg, #74b8be 0%, #3c638f 100%) 0%
    0% no-repeat padding-box;
}
</style>
